import { render, staticRenderFns } from "./SliderContainer.vue?vue&type=template&id=d178d32c"
import script from "./SliderContainer.vue?vue&type=script&lang=js"
export * from "./SliderContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports